import React from 'react';
import { withRouter, Link } from 'react-router';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import filter from 'lodash/filter';
// import { StripeProvider, Elements, injectStripe } from 'react-stripe-elements';
// import CreateSubscriptionButton from './ModalButtons/CreateSubscription';
import OrganizationSubscriptionsList from './OrganizationSubscriptionsList';
import OrgTabs from './OrganizationTabs';
import Loading from '../../components/Loading';

// const CreatePlanButton = injectStripe(CreatePlanForm);

const queryOrganization = gql`
  query Organization($id: ID!) {
    organization(id: $id) {
      id
      name
    }
    cards(organizationId: $id) {
      id
      organization_id
      brand
      last4
      exp_month
      exp_year
      is_default
    }
    purchaseOrders(organizationId: $id) {
      id
      organization_id
      props
    }
  }
`;

const withData = graphql(queryOrganization, {
  options: ({ params }) => ({
    variables: {
      id: params.organizationId,
    },
    fetchPolicy: 'network-only',
  }),
});

@withRouter
@withData
// @connect()
export default class Organization extends React.Component {
  getDefaultCard = cardsList => {
    const result = filter(cardsList, { is_default: true });
    return result[0] || null;
  };

  handleOnClick = () => {
    const { params: { organizationId }, router } = this.props;
    router.push(`/admin/organization/${organizationId}/subscriptions/create`);
  };

  render() {
    const {
      data: { organization, cards, purchaseOrders, loading },
      params: { organizationId },
    } = this.props;
    if (loading) return <Loading />;
    if (!organization) return null;
    const defaultCard = this.getDefaultCard(cards);
    // console.log('purchaseOrders: ', purchaseOrders, defaultCard);
    const enableCreate = (purchaseOrders && purchaseOrders.length) || defaultCard;

    return (
      <div>
        <h2>{organization.name} Subscriptions</h2>
        <OrgTabs />
        {/* <CreateSubscriptionButton /> */}
        <button
          type="button"
          className="btn btn-primary btn-sm mb-2"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            this.handleOnClick();
          }}
          disabled={!enableCreate}
        >
          <i
            className="fa fa-plus mr-1"
            aria-hidden="true"
            style={{ marginRight: 5 }}
          />
          Create Subscription
        </button>
        {!enableCreate && (
          <span className="text-danger ml-3" style={{ fontSize: 11 }}>
            No payment method set.{' '}
            <Link
              to={`/admin/organization/${organizationId}/billing`}
              style={{ color: '#dc3545' }}
            >
              Click here
            </Link>{' '}
            to add one.
          </span>
        )}

        <OrganizationSubscriptionsList organization={organization} />
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/Organization.js